export const INT_PARAMETER = 'intParameter';
export const PARAMETER = 'parameter';
